"use strict";

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BN = require("bn.js");

var bignumber_js_1 = require("bignumber.js");

var Utils =
/** @class */
function () {
  function Utils() {}

  Utils.bigNumberToBN = function (value) {
    return new BN(new bignumber_js_1.BigNumber(value).toFixed(), 10);
  };

  Utils.bnToBigNumber = function (value) {
    return new bignumber_js_1.BigNumber(value.toString(10), 10);
  };

  Utils.normalizeAddress = function (address) {
    var toLowerAddress = address.toLowerCase();

    if (toLowerAddress.startsWith('0x')) {
      return toLowerAddress;
    }

    return '0x' + toLowerAddress;
  };

  Utils.normalizeNumber = function (value) {
    if (value instanceof BN) {
      return Utils.bnToBigNumber(value);
    }

    if (value instanceof bignumber_js_1.BigNumber) {
      return value;
    }

    return new bignumber_js_1.BigNumber(value);
  };

  return Utils;
}();

exports.Utils = Utils;